module.exports = __webpack_public_path__ + "static/img/1000016icon.869483e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1000016icon.png
// module id = xMQp
// module chunks = 1